var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37372 11.3351C7.00642 11.3351 6.70866 11.6329 6.70866 12.0002C6.70866 12.3675 7.00642 12.6652 7.37372 12.6652H16.6267C16.994 12.6652 17.2918 12.3675 17.2918 12.0002C17.2918 11.6329 16.994 11.3351 16.6267 11.3351H7.37372Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.173494,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4.62651,
    fill: "#4E2D92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37372 11.3351C7.00642 11.3351 6.70866 11.6329 6.70866 12.0002C6.70866 12.3675 7.00642 12.6652 7.37372 12.6652H16.6267C16.994 12.6652 17.2918 12.3675 17.2918 12.0002C17.2918 11.6329 16.994 11.3351 16.6267 11.3351H7.37372Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.173494,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionClose);
export default __webpack_public_path__ + "static/media/accordion_close.6887800f09dadbc65d40ef0ff86eafe5.svg";
export { ForwardRef as ReactComponent };